
import 'survey-core/defaultV2.min.css';
import { SimpleQuestionnaire } from './components/SimpleQuestionnaire';

/**
 * Main App component that renders the simple questionnaire
 */
function App() {
  return (
    <div className="App">
      <SimpleQuestionnaire />
    </div>
  );
}

export default App;
